export default [
  {
    path: '/intercom',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '/intercom/',
        name: 'intercomManagement',
        component: () => import('@/views/Intercom/IntercomManagement.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'callRecordList' }
          },
          {
            path: 'callRecordList',
            name: 'callRecordList',
            component: () => import('@/views/Intercom/CallRecordList.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'sentryManagement',
            name: 'sentryManagement',
            component: () => import('@/views/Intercom/SentryManagement.vue'),
            meta: {
              prev: 'goHome'
            }
          },
          {
            path: 'residentOpen',
            name: 'residentOpen',
            component: () => import('@/views/Intercom/ResidentOpen.vue'),
            meta: {
              prev: 'goHome'
            }
          }
        ]
      },
      {
        path: 'cloudintercom/:publicCode',
        component: () => import('@/views/Intercom/CloudIntercom/CloudIntercom.vue'),
        children: (function () {
          // App.vue 直接讀 $route.meta（葉路由），不會自動繼承父層 meta，
          // 因此每個子路由都需要帶上相同的 meta 以確保 header / footer / 登入守衛正確運作
          const meta = {
            isNoNeedToLogin: true,
            header: 'none',
            footer: 'none',
            logoutinfo: 'none'
          }
          const metaWithBadge = { ...meta, showRecaptchaBadge: true }
          return [
            { path: '', redirect: to => ({ name: 'cloudIntercomWelcome', params: to.params }) },
            { path: 'welcome', name: 'cloudIntercomWelcome', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/WelcomePage.vue') },
            { path: 'blocking', name: 'cloudIntercomBlocking', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/BlockingPage.vue') },
            { path: 'location-denied', name: 'cloudIntercomLocationDenied', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/LocationDeniedPage.vue') },
            { path: 'out-of-range', name: 'cloudIntercomOutOfRange', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/OutOfRangePage.vue') },
            { path: 'media-permission', name: 'cloudIntercomMediaPermission', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/MediaPermissionPage.vue') },
            { path: 'media-denied', name: 'cloudIntercomMediaDenied', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/MediaDeniedPage.vue') },
            { path: 'home', name: 'cloudIntercomHome', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/HomePage.vue') },
            { path: 'verification', name: 'cloudIntercomVerification', meta, component: () => import('@/views/Intercom/CloudIntercom/VerificationPage.vue') },
            { path: 'registration', name: 'cloudIntercomRegistration', meta, component: () => import('@/views/Intercom/CloudIntercom/RegistrationPage.vue') },
            { path: 'callees', name: 'cloudIntercomCallees', meta, component: () => import('@/views/Intercom/CloudIntercom/CalleesPage.vue') },
            { path: 'timeout', name: 'cloudIntercomTimeout', meta: metaWithBadge, component: () => import('@/views/Intercom/CloudIntercom/TimeoutPage.vue') }
          ]
        }())
      }
    ]
  }
]
